module.exports = __webpack_public_path__ + "img/bg-pattern-intro.18be6c77.svg";